import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, EnumDecoder, field, IntegerDecoder, MapDecoder, StringDecoder } from "@simonbackx/simple-encoding";
import { SimpleError } from "@simonbackx/simple-errors";
import { Address } from "./Address";
import { Checkout } from "./Checkout";
import { CheckoutCode } from "./CheckoutCode";
import { Business, ContactPerson, PrivateCustomer } from "./Customer";
import { File } from "./files/File";
import { OrderPrices } from "./OrderPrices";
import { PaymentMethod } from "./PaymentMethod";
import { PaymentStatus } from "./PaymentStatus";
/**
 * Make some properties required when saved in an order
 */
export class OrderData extends Checkout {
    constructor() {
        super(...arguments);
        this.prices = OrderPrices.create({});
        // Keep track of returned cups / items with warranty
        this.returnedProducts = new Map();
        this.code = null;
    }
    /**
     * Calculate the warranty that the user has to pay for loss of products, given the returned products, and the warranty during ordering
     */
    calculateWarrantyMissing(products) {
        var _a;
        let warranty = 0;
        for (const item of this.cart.items) {
            const returnedAmount = (_a = products.get(item.product.id)) !== null && _a !== void 0 ? _a : 0;
            warranty += item.product.prices.warranty * (item.amount - returnedAmount);
        }
        return warranty;
    }
    calculateWarranty(products) {
        var _a;
        let warranty = 0;
        for (const item of this.cart.items) {
            const returnedAmount = (_a = products.get(item.product.id)) !== null && _a !== void 0 ? _a : 0;
            warranty += item.product.prices.warranty * returnedAmount;
        }
        return warranty;
    }
    static fromCheckout(checkout) {
        if (checkout.business === null) {
            throw new SimpleError({
                code: "invalid_field",
                message: "Business is required",
                field: "business"
            });
        }
        if (checkout.contactPerson === null) {
            throw new SimpleError({
                code: "invalid_field",
                message: "contactPerson is required",
                field: "contactPerson"
            });
        }
        if (checkout.deliveryAddress === null) {
            throw new SimpleError({
                code: "invalid_field",
                message: "deliveryAddress is required",
                field: "deliveryAddress"
            });
        }
        return OrderData.create(checkout);
    }
    updatePrices() {
        this.prices = this.calculatedPrices;
    }
}
__decorate([
    field({ decoder: Business })
], OrderData.prototype, "business", void 0);
__decorate([
    field({ decoder: ContactPerson })
], OrderData.prototype, "contactPerson", void 0);
__decorate([
    field({ decoder: Address })
], OrderData.prototype, "deliveryAddress", void 0);
__decorate([
    field({ decoder: OrderPrices })
], OrderData.prototype, "prices", void 0);
__decorate([
    field({ decoder: new EnumDecoder(PaymentMethod) })
], OrderData.prototype, "paymentMethod", void 0);
__decorate([
    field({ decoder: File, optional: true })
], OrderData.prototype, "pdf", void 0);
__decorate([
    field({ decoder: File, optional: true })
], OrderData.prototype, "orderFormPdf", void 0);
__decorate([
    field({ decoder: new MapDecoder(StringDecoder, IntegerDecoder), version: 5 })
], OrderData.prototype, "returnedProducts", void 0);
__decorate([
    field({ decoder: CheckoutCode, nullable: true, optional: true })
], OrderData.prototype, "code", void 0);
export class Order extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.paidAt = null;
        this.number = null;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], Order.prototype, "id", void 0);
__decorate([
    field({ decoder: OrderData })
], Order.prototype, "data", void 0);
__decorate([
    field({ decoder: new EnumDecoder(PaymentStatus) })
], Order.prototype, "paymentStatus", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], Order.prototype, "paidAt", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true })
], Order.prototype, "number", void 0);
__decorate([
    field({ decoder: DateDecoder })
], Order.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder })
], Order.prototype, "updatedAt", void 0);
export class PrivateOrder extends Order {
    constructor() {
        super(...arguments);
        /**
         * @deprecated
         * This is not used
         */
        this.customer = null;
    }
}
__decorate([
    field({ decoder: PrivateCustomer, nullable: true })
], PrivateOrder.prototype, "customer", void 0);
export class OrderResponse extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.paymentUrl = null;
    }
}
__decorate([
    field({ decoder: Order })
], OrderResponse.prototype, "order", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], OrderResponse.prototype, "paymentUrl", void 0);
//# sourceMappingURL=Order.js.map